/* eslint-disable ember/no-computed-properties-in-native-classes */
import { QUESTION_NAMES, QUESTION_TYPES } from 'client-portal/utils/prescreener/constants';
import { buildValidations, validator } from 'ember-cp-validations';
import { not, reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import moment from 'moment-timezone';

const Validations = buildValidations({
  value: [
    validator('inline', {
      validate(value, options, model) {
        const errorMessageKey = model.validationMessageKeys?.required;
        if (!errorMessageKey) return true;

        if (model.type === QUESTION_TYPES.MULTISELECT) {
          return (Array.isArray(value) && value.length > 0) || errorMessageKey;
        }

        if (model.type === QUESTION_TYPES.FILE) {
          return model.customValidator(value, model) || errorMessageKey;
        }

        if (model.name === QUESTION_NAMES.DATE_OF_BIRTH) {
          return (value && moment(value)?.isBefore(moment())) || errorMessageKey;
        }

        return (value && String(value).trim() !== '') || errorMessageKey;
      },
      disabled: not('model.required'),
    }),
    validator('length', {
      max: reads('model.maxLength'),
      disabled: not('model.maxLength'),
      message: reads('model.validationMessageKeys.maxLength'),
    }),
  ],
});

/* eslint-enable ember/no-computed-properties-in-native-classes */

export default class PrescreenerAnswerValidationModel extends Model.extend(Validations) {
  @service prescreener;

  @attr('string') name;
  @attr('string') type;

  @attr('string') category;
  @attr('boolean') required;
  @attr('number') maxLength;
  @attr('string') validationMessageKeys;
  @attr('string') clientType;

  @attr() value;
  @attr() customValidator;
}
